<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg"><br>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <div
                v-for="(item, index) in cart" :key="index"
                class="card row"
              >
                <div class="col-md-4">
                  <!-- <img src="../../../assets/images/rewards/hat.jpg" alt="" class="img-responsive"> -->
                  <img :src="item.imageUrl" :alt="item.name" class="img-responsive">
                </div>
                <div class="col-md-8">
                  <div class="item-content v-center">
                    <span>Name: {{ item.name }}</span>
                    <span v-if="item.size">Size: {{ item.size }}</span>
                    <span v-if="item.color">Color: {{ item.color }}</span>
                    <span>Quantity: {{ item.quantity }}</span>
                    <span>Cost: {{ item.points * item.quantity }}</span>
                    <button @click="removeCartItem(item)" class="btn btn-small btn-danger">Remove</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 redeem-sec">
          <div class="row">
            <div class="cart-summary-content col-md-10 col-md-offset-1">
              <div class="current-points row">
                <h2>Current Points:</h2>
                <span class="grey-type med-numbers">
                  {{ user.userLoyaltyProgram.currentPoints }}
                </span>
              </div>
              <div class="current-cost row">
                <h2>Total Cost:</h2>
                <span class="grey-type med-numbers">
                  {{ totalCost }}
                </span>
              </div>
              <div class="current-cost row">
                <h2>Remaining Points:</h2>
                <span :class="remainingClasses">
                  {{ remainingPoints }}
                </span>
              </div>
              <br>
              <br>
              <div class="current-cost row">
                <a
                  type="button"
                  class="btn client-btn-primary btn-lg btn-block text-uppercase"
                  @click.prevent="goRewardCatalog"
                >
                  Add Another Item
                </a>
                <a
                  type="button"
                  class="btn client-btn-primary btn-lg btn-block text-uppercase"
                  @click.prevent="emptyCart"
                >
                  Empty Cart
                </a>
                <a
                  type="button"
                  class="btn client-btn-primary btn-lg btn-block text-uppercase"
                  :disabled="!validCart"
                  @click.prevent="submit"
                >
                  Submit
                </a>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  name: 'CartItems',
  mounted () {
    this.clientGetCartRewardItems(this.user.userLoyaltyProgram._id)
      .catch(err => console.log(err))
  },
  computed: {
    ...mapGetters('cartRewardItem', {
      cart: 'unsubmittedItems'
    }),
    ...mapState('user', ['user']),
    totalCost () {
      return this.cart.reduce((sum, item) => {
        sum += (item.points * item.quantity)
        return sum
      }, 0)
    },
    remainingPoints () {
      return this.user.userLoyaltyProgram.currentPoints - this.totalCost
    },
    validCart () {
      return this.remainingPoints >= 0
    },
    remainingClasses () {
      return this.validCart ? 'grey-type med-numbers' : 'red-type med-numbers'
    }
  },
  methods: {
    ...mapActions('cartRewardItem', [
      'clientGetCartRewardItems',
      'clientRemoveCartRewardItem',
      'clientSubmitCart',
      'clientEmptyCart'
    ]),
    ...mapActions('user', ['getUser']),
    removeCartItem (item) {
      this.clientRemoveCartRewardItem(item)
    },
    emptyCart () {
      this.clientEmptyCart({ userLoyaltyProgramId: this.user.userLoyaltyProgram._id })
        .then((result) => {
          this.$router.push({ name: 'ClientDashboard' })
        })
    },
    submit () {
      if (!this.validCart) {
        return
      }

      this.$bus.emit('global-load', { load: true, message: 'Submitting cart', env: 'client' })

      this.clientSubmitCart({
        userLoyaltyProgramId: this.user.userLoyaltyProgram._id,
        totalCost: this.totalCost,
        currentPoints: this.remainingPoints
      })
        .then((result) => {
          this.$bus.emit('global-load', { load: false })
          this.$router.push({ name: 'ClientDashboard' })
          this.$bus.emit('notify', { message: 'Successfully submitted to cart.', type: 'info' })
        })
        .catch((err) => {
          console.log(err.response.data.msg)
          this.$bus.emit('global-load', { load: false })
          this.$bus.emit('notify', { message: 'There was an error submitting to your cart, please try again.', type: 'danger' })
          this.getUser()
        })
    },
    goRewardCatalog () {
      this.$bus.emit('swapComponent', { component: 'reward-catalog' })
    }
  }
}
</script>

<style scoped>
.card {
  border: 1px solid rgba(42, 42, 42,.60);
  -webkit-box-shadow: 0px 0px 5px rgba(42, 42, 42,0.75);
  box-shadow: 0px 0px 5px rgba(42, 42, 42,0.75);
  padding: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  color: #333;
}

.card img {
  max-height: 100px;
}

.v-center {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.v-center span {
}

.redeem-sec h2{
  margin:0px;
  padding:0px;
  font-weight: 300;
}

.med-numbers{
  font-size:3em;
}
</style>
